<template>
  <!-- <h3>CustomRoom ID: {{id}}</h3> -->
  <button
    id="closeButton"
    v-if="isMobile && chatOn && showSketch"
    class="btn btn-danger"
    @click="closeChat"
  >
    Close Chat
  </button>
  <button
    id="closeUser"
    v-if="isMobile && peopleOn && showSketch"
    class="btn btn-danger"
    @click="closePeople"
  >
    Close User List
  </button>
  <JoinPage v-if="showJoinPage" />
  <WaitingRoom v-if="showWaitingRoom" />
  <UserList v-if="showSketch && peopleOn" />

  <Sketch v-if="showSketch" />
  <Chat v-if="showSketch && chatOn" />
  <SelectWord
    v-if="showSelectWord && roomData.isPlaying"
    :roomId="roomData.roomId"
    @ISelectedWord="sendWordToServer($event)"
  />
  <GameOver v-if="roomData.gameOver" />
  <div class="bottom-mobile" v-if="isMobile && showSketch">
    <button class="btn btn-secondary option-button1" @click="openPeople">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="currentColor"
        class="bi bi-people-fill"
        viewBox="0 0 16 16"
      >
        <path
          d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
        />
        <path
          fill-rule="evenodd"
          d="M5.216 14A2.238 2.238 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1h4.216z"
        />
        <path d="M4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z" />
      </svg>
    </button>
    <button class="btn btn-secondary option-button2" @click="openChat">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="currentColor"
        class="bi bi-chat-fill"
        viewBox="0 0 16 16"
      >
        <path
          d="M8 15c4.418 0 8-3.134 8-7s-3.582-7-8-7-8 3.134-8 7c0 1.76.743 3.37 1.97 4.6-.097 1.016-.417 2.13-.771 2.966-.079.186.074.394.273.362 2.256-.37 3.597-.938 4.18-1.234A9.06 9.06 0 0 0 8 15z"
        />
      </svg>
    </button>
  </div>
</template>

<script>
// @ is an alias to /src
import * as socketio from "../plugins/socketio";
import WaitingRoom from "@/components/WaitingRoom.vue";
import Sketch from "@/components/Sketch.vue";
import SelectWord from "../components/SelectWord.vue";
import JoinPage from "../components/JoinPage.vue";
import UserList from "../components/UserList.vue";
import Chat from "../components/Chat.vue";
import GameOver from "../components/GameOver.vue";

export default {
  name: "Doodle",
  props: ["id"],
  components: {
    WaitingRoom,
    Sketch,
    SelectWord,
    JoinPage,
    UserList,
    Chat,
    GameOver,
  },
  data() {
    return {
      customRoomId: this.id,
      roomData: "",
      showWaitingRoom: false,
      showSketch: false,
      socketId: null,
      showJoinPage: true,
      showSelectWord: false,
      wordToGuess: "",
      isMaster: false,
      isMobile: false,
      peopleOn: true,
      chatOn: true,
    };
  },
  mounted() {
    this.isMobile = window.matchMedia("(max-width: 768px)").matches;

    console.log(this.isMobile);

    if (this.isMobile) {
      this.peopleOn = false;
      this.chatOn = false;
    }

    socketio.addEventListener({
      type: "roomState",
      callback: (roomData) => {
        this.roomData = roomData;
        this.showWaitingRoom = !roomData.isPlaying;
        this.showJoinPage = false;
        this.showSketch = roomData.isPlaying;
        this.wordToGuess = roomData.guessWord;
        this.isMaster = roomData.roomMaster.playerSocketId == this.socketId;
      },
    });
    socketio.addEventListener({
      type: "player",
      callback: (playerData) => {
        console.log(playerData);
        this.socketId = playerData.playerSocketId;
      },
    });
    // socketio.addEventListener({
    //       type: 'chooseAWord',
    //       callback: ({roomMaster}) => {
    //           if (roomMaster.playerSocketId === socketio.clientSocketId()) {
    //             console.log('choosig wait dude')
    //               this.showSelectWord = true
    //           }
    //       }
    //   })
    socketio.addEventListener({
      type: "chooseAWord",
      callback: () => {
        console.log("wow only I");
        this.showSelectWord = true;
      },
    });
  },
  methods: {
    sendWordToServer(word) {
      console.log("Sending ", word);
      socketio.sendEvent({
        type: "wordSelected",
        data: { word: word, roomId: this.roomData.roomId },
      });
      this.showSelectWord = false;
    },
    openPeople() {
      this.peopleOn = true;
    },
    openChat() {
      this.chatOn = true;
    },
    closeChat() {
      this.chatOn = false;
    },
    closePeople() {
      this.peopleOn = false;
    },
  },
};
</script>

<style>
body {
  background-image: url("../assets/Background.svg");
  width: 100vw;
  height: 100vh;
  background-repeat: no-repeat;
  background-size: cover;
}
@media (max-width: 500px) {
  body {
    overflow-y: scroll;
    width: 100vw;
    height: 113vh;
  }
}
.bottom-mobile {
  width: 100vw;
  height: 70px;
  display: flex;
}
.option-button1 {
  margin-right: auto;
  margin-left: 5px;
  width: 50px;
  height: 50px;
}
.option-button2 {
  margin-left: auto;
  margin-right: 5px;
  width: 50px;
  height: 50px;
}
#closeButton {
  display: block;
  margin: auto;
  z-index: 4;
  position: absolute;
  left: 37vw;
  top: 5vh;
}
#closeUser {
  display: block;
  margin: auto;
  z-index: 5;
  position: absolute;
  left: 35vw;
  bottom: 5vh;
}
</style>
